import React, { FC, useEffect } from "react";
import styled from "styled-components";

import { usePlayerStore } from "../../../store/usePlayerStore";
import { ErrorPayloadType, HlsJsErrorPayload } from "../../../types/common";
import { Error } from "../../NonPlayable/Error";

const ErrorOverlayWrapper = styled.div`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;
`;

const isHlsJsErrorPayload = (
  error: ErrorPayloadType
): error is HlsJsErrorPayload =>
  !!(error as HlsJsErrorPayload).type || !!(error as HlsJsErrorPayload).details;

export const ErrorOverlay: FC = () => {
  const { useStoreState } = usePlayerStore();
  const error = useStoreState.error();
  const errorOverlayVisible = useStoreState.errorOverlayVisible();
  const player = useStoreState.player();

  const setErrorOverlayVisible = useStoreState.setErrorOverlayVisible();

  useEffect(() => {
    setErrorOverlayVisible(
      !!error && isHlsJsErrorPayload(error) && !!error.fatal
    );
  }, [error, setErrorOverlayVisible]);

  useEffect(() => {
    if (errorOverlayVisible) {
      player.pause();
    }
  }, [errorOverlayVisible, player]);

  return (
    error &&
    errorOverlayVisible && (
      <ErrorOverlayWrapper>
        <Error />
      </ErrorOverlayWrapper>
    )
  );
};
